<section
  *ngIf="!maintenance"
  [formGroup]="form"
  class="mt-4"
  aria-labelledby="match-settings-title"
>
  <h3 id="match-settings-title" class="mb-2 font-semibold">Match settings</h3>

  <mat-radio-group
    formControlName="bookingType"
    aria-label="Match visibility"
    class="flex gap-5"
  >
    <mat-radio-button value="private">Private</mat-radio-button>
    <mat-radio-button value="public">Public</mat-radio-button>
  </mat-radio-group>

  <mat-form-field
    *ngIf="isPublic"
    class="mt-3 w-full"
    subscriptSizing="dynamic"
  >
    <mat-label>Player capacity</mat-label>
    <input
      matInput
      type="number"
      inputmode="numeric"
      formControlName="slots"
      [attr.min]="minCapacity"
      [attr.max]="maxCapacity"
      step="1"
    />
    <mat-hint *ngIf="minCapacity !== null && maxCapacity !== null">
      Allowed range: {{ minCapacity }} to {{ maxCapacity }} players
    </mat-hint>
    <mat-error *ngIf="form.get('slots')?.hasError('required')">
      Player capacity is required for public matches.
    </mat-error>
    <mat-error *ngIf="form.get('slots')?.hasError('integer')">
      Player capacity must be a whole number.
    </mat-error>
    <mat-error
      *ngIf="
        form.get('slots')?.hasError('min') || form.get('slots')?.hasError('max')
      "
    >
      Player capacity must be within the selected court's allowed range.
    </mat-error>
  </mat-form-field>

  <mat-form-field
    *ngIf="isPublic"
    class="mt-3 w-full"
    subscriptSizing="dynamic"
  >
    <mat-label>Match format</mat-label>
    <mat-select formControlName="format">
      <mat-option *ngFor="let option of matchFormats" [value]="option">
        {{ option }}
      </mat-option>
    </mat-select>
    <mat-hint
      >Use the format supported by the selected sport and court.</mat-hint
    >
    <mat-error *ngIf="form.get('format')?.invalid">
      Match format is required for public matches.
    </mat-error>
  </mat-form-field>

  <mat-form-field
    *ngIf="isPublic"
    class="mt-3 w-full"
    subscriptSizing="dynamic"
  >
    <mat-label>Composition</mat-label>
    <mat-select formControlName="composition">
      <mat-option value="mixed">Mixed</mat-option>
      <mat-option value="men">Men</mat-option>
      <mat-option value="women">Women</mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('composition')?.hasError('required')">
      Composition is required for public matches.
    </mat-error>
  </mat-form-field>

  <mat-slide-toggle
    *ngIf="isPublic && showMatchmakingToggle"
    class="mt-4 block"
    formControlName="startMatchmaking"
    color="primary"
    [attr.aria-describedby]="
      matchmakingUnavailable ? 'matchmaking-full-message' : null
    "
  >
    Set up Match Making after saving
  </mat-slide-toggle>
  <span
    *ngIf="matchmakingUnavailable"
    id="matchmaking-full-message"
    class="mt-1 block text-sm text-gray-500"
  >
    Match Making unavailable — Match is full
  </span>
</section>
